// extracted by mini-css-extract-plugin
export default {"wrapper":"Text_wrapper__Rak+g","inner":"Text_inner__91rC3","alignmentCenter":"Text_alignmentCenter__bAouE","tagline":"Text_tagline__a4qPC"};